import React from 'react';
import AddUser from './AddUser';
import UserShow from './UserShow';

const CrudSetUp = () => {
    return (
        <div>
            <AddUser></AddUser>
            <UserShow></UserShow>
        </div>
    );
};

export default CrudSetUp;